import type React from 'react'

import { DescriptionWrapper } from '../DescriptionWrapper'

interface Props {
  members: number
}

const PRICE = 48

export const DescriptionTeam: React.FC<Props> = ({ members }) => {
  const savedPrice = members * PRICE

  return (
    <DescriptionWrapper>
      Save <b>${savedPrice}</b> Every Year.
      <br /> More teamwork, less billing.
    </DescriptionWrapper>
  )
}
